export default [
    {
        path: "point-analysis",
        name: "PointAnalysis",  
        meta:{
            permissionPath: 'history.points_analysis',
        },
        component: () =>
            import(
                /* webpackChunkName: "pointAnalysis" */ "@/views/storePanel/history/tabs/PointAnalysis.vue"
            )
    },

    {
        path: "monthly-points",
        name: "MonthlyPoints",
        meta:{
            permissionPath: 'history.monthly_points',
        },
        component: () =>
            import(
                /* webpackChunkName: "monthlyPoints" */ "@/views/storePanel/history/tabs/MonthlyPoints.vue"
            )
    }
];
